import { render, staticRenderFns } from "./Mensajeria.vue?vue&type=template&id=33e6f3d1&"
import script from "./Mensajeria.vue?vue&type=script&lang=js&"
export * from "./Mensajeria.vue?vue&type=script&lang=js&"
import style0 from "./Mensajeria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports